import React, { useMemo } from 'react';
import { ButtonV2 } from '@withjoy/joykit';
import { useFormById } from '@shared/components/EventForm/components/data/hooks/useFormById';
import { FormType } from '@graphql/generated';
import { getSolidButtonStylesWithAccentAndTextColor, useColorPaletteProvider } from '@apps/guest';

const getFormLink = (formId: string, eventId: string, isRegistration?: boolean) => {
  return `${window?.location.origin}/${eventId}/${isRegistration ? 'registration' : 'form'}/${formId}`;
};

type FormLinkButtonProps = {
  formId: string;
  eventId: string;
  ctaText?: string;
};

export const FormLinkButton = (props: FormLinkButtonProps) => {
  const { formId, eventId, ctaText } = props;
  const { data, loading } = useFormById(formId);

  const { accentColor, pageFontColor } = useColorPaletteProvider();
  const buttonStyles = useMemo(() => (accentColor && pageFontColor ? getSolidButtonStylesWithAccentAndTextColor(accentColor, pageFontColor) : {}), [accentColor, pageFontColor]);

  if (!formId) {
    return null;
  }

  const isRegistration = data?.type === FormType.REGISTRATION;

  const formLink = getFormLink(formId, eventId, isRegistration);

  return (
    <ButtonV2
      as="a"
      href={formLink}
      disabled={loading}
      shape="rounded"
      {...buttonStyles}
    >
      {ctaText ?? 'Open Form'}
    </ButtonV2>
  );
};
